const API_ROOT = 'https://alcobrakeadmin.com/v3';
const APPOINTMENTS_URL = process.env.REACT_APP_APPOINTMENTS_API_URL || `${API_ROOT}/us/appointments`;

const readResponse = async (response) => {
  const text = await response.text();
  let data = text;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (_) {
    // Some existing Alcobrake endpoints return plain-text success responses.
  }

  if (!response.ok) {
    const message = data?.message || data?.error || text || `Request failed (${response.status})`;
    throw new Error(message);
  }

  return data;
};

export const appointmentsAPI = {
  getAppointments: async (dealerId) => {
    const response = await fetch(`${APPOINTMENTS_URL}/getdealerappointments?dealerId=${encodeURIComponent(dealerId)}`);
    return readResponse(response);
  },

  getDealerVehicles: async (dealerId) => {
    const response = await fetch(`${API_ROOT}/app/v2data/getdealerlatestupdates3?dealerId=${encodeURIComponent(dealerId)}`);
    return readResponse(response);
  },

  addAppointment: async (appointment) => {
    const formData = new FormData();
    Object.entries(appointment).forEach(([key, value]) => formData.append(key, value ?? ''));

    const response = await fetch(`${APPOINTMENTS_URL}/addappointment`, {
      method: 'POST',
      body: formData,
    });
    return readResponse(response);
  },

  cancelAppointment: async (appointmentId) => {
    const formData = new FormData();
    formData.append('id', appointmentId);
    const response = await fetch(`${APPOINTMENTS_URL}/cancelappointment`, {
      method: 'POST',
      body: formData,
    });
    return readResponse(response);
  },
};
